import { render, staticRenderFns } from "./CheckRepetion.vue?vue&type=template&id=fbc56e8e&scoped=true"
import script from "./CheckRepetion.vue?vue&type=script&lang=js"
export * from "./CheckRepetion.vue?vue&type=script&lang=js"
import style0 from "./CheckRepetion.vue?vue&type=style&index=0&id=fbc56e8e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbc56e8e",
  null
  
)

export default component.exports